import _ from "underscore"
window._ = _
import "jquery/src/jquery"

/**
 * Marmoset Music global namespace
 * @type {Object}
 */

var mm = (window.mm = {})

mm.hasHistory = "pushState" in window.history ? true : false
